import { ContactForm } from "@/components";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import Styles from "./Contact.module.css";

const Default = ({ primary, items }) => {
	return (
		<section className={Styles.wrapper}>
			<div
				className={Styles.background}
				data-background={primary?.no_background_image}
			>
				<PrismicNextImage
					field={primary?.background_image}
					className={Styles.backgroundImage}
				/>
				<div className={Styles.overlay}>
					<div className={Styles.container} data-contain="true">
						<div className={Styles.col}>
							<span className={Styles.heading}>
								<PrismicRichText field={primary?.heading} />
							</span>
							<span className={Styles.description}>
								<PrismicRichText field={primary?.description} />
							</span>
						</div>
					</div>
				</div>
			</div>
			<div className={Styles.container} data-contain="true">
				<div className={Styles.innerContainer}>
					<div className={Styles.col}>
						{items.length > 0 && (
							<>
								<h4 className={Styles.locationHeading}>Locations</h4>
								{items.map((item, index) => (
									<div className={Styles.location} key={index}>
										<PrismicRichText field={item?.location} />
									</div>
								))}
							</>
						)}
					</div>
					<div className={Styles.col}>
						<ContactForm />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Default;
